import { render } from "./BotEmails.vue?vue&type=template&id=bc67faba"
import script from "./BotEmails.vue?vue&type=script&lang=js"
export * from "./BotEmails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__